module.exports = __webpack_public_path__ + "img/0017.36ddfc61.gif";